import React from 'react';

const ImageJs = (props) => (
    <svg {...props} width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 9.33398V14.334C1 14.776 1.17559 15.1999 1.48816 15.5125C1.80072 15.8251 2.22464 16.0007 2.66667 16.0007H17.6667C18.1087 16.0007 18.5326 15.8251 18.8452 15.5125C19.1577 15.1999 19.3333 14.776 19.3333 14.334V9.33398"
            stroke="#fff"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M19.3333 5.16667V2.66667C19.3333 2.22464 19.1577 1.80072 18.8452 1.48816C18.5326 1.17559 18.1087 1 17.6667 1H2.66667C2.22464 1 1.80072 1.17559 1.48816 1.48816C1.17559 1.80072 1 2.22464 1 2.66667V5.16667L10.1667 10.1667L19.3333 5.16667Z"
            stroke="#fff"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
    </svg>
);

export default ImageJs;
